// Move the icons block to the bottom of __body on mobile, restore it on desktop.
function initIconsLayout(section) {
  const icons = section.querySelector('.section-custom-hero__icons');
  if (!icons) return;

  const body = section.querySelector('.section-custom-hero__body');
  if (!body) return;

  // Remember original position so we can restore it on desktop.
  const originalParent = icons.parentElement;
  const originalNext   = icons.nextElementSibling;

  const mq = window.matchMedia('(max-width: 749px)');

  function update({ matches }) {
    if (matches) {
      body.appendChild(icons);
    } else {
      originalNext
        ? originalParent.insertBefore(icons, originalNext)
        : originalParent.appendChild(icons);
    }
  }

  mq.addEventListener('change', update);
  update(mq);
}

function initCustomHero(section) {
  initIconsLayout(section);

  const readMoreBtn = section.querySelector('.section-custom-hero__read-more');
  const expandable  = section.querySelector('.section-custom-hero__expandable');

  if (!readMoreBtn || !expandable) return;

  section.classList.add('js-hero-ready');

  readMoreBtn.addEventListener('click', () => {
    const isOpen = readMoreBtn.getAttribute('aria-expanded') === 'true';
    const next   = !isOpen;

    readMoreBtn.setAttribute('aria-expanded', String(next));
    expandable.classList.toggle('is-open', next);

    const textEl = readMoreBtn.querySelector('.section-custom-hero__read-more-text');
    if (textEl) textEl.textContent = next ? 'Read less' : 'Read more';
  });
}

document.querySelectorAll('[data-section-custom-hero]').forEach(initCustomHero);

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('[data-section-custom-hero]');
  if (section) initCustomHero(section);
});
